import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";

import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../analytics";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../look/core/constants";
import {setLookIntroStep, setLookOverlayOpened} from "../../../actions/lookFunctions";
import {AiIcon2} from "../../common/svgIcons/svgIcons";
import LookIntroPopper from "../../look/lookNavigation/lookIntro/lookIntroPopper";
import {getCommonVisualizerType} from "../../../config";
import {setLookAiImageOpened} from "../aiActions";
import LookSideBarAIPanelFinishedRenderContent from "./LookSideBarAIPanelFinishedRenderContent";
import LookSideBarAIPanelFinishedRenderPopper from "./LookSideBarAIPanelFinishedRenderPopper";
// import {useAnimationFinishedTeaser} from "./useAnimationFinishedTeaser";

const LookSideBarAIMobileButton2 = (props) => {

  const {intl, lookPageOpened, sidebarButtonClicked, popupCloseClick, disabled, setLookOverlayOpened, aiResults,
    introStep, setLookIntroStep, setLookAiImageOpened, lookAiRenderFinished, lookOverlayOpened, fabricatorData} = props;
  // fabricatorData, aiLoading

  const anchorRef = useRef(null);
  const anchorRollout = useRef(null);
  const neededIntroStep = LOOK_INTRO_STEPS.aiStep;
  const introIsActive = introStep !== LOOK_INTRO_STEPS.welcome;

  if (!fabricatorData.aiSettings.enableAI) {
    return null;
  }

  // const {animationActive, animationShown} = useAnimationFinishedTeaser({fabricatorData, aiLoading, lookOverlayOpened})

  const aiButtonClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarMobileAi);
    if (introIsActive) {
      setLookIntroStep();
      return false;
    }
    if (lookPageOpened && popupCloseClick) {
      popupCloseClick();
    } else {
      setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
      const someResultExist = aiResults.some(res => res.resultImageUrl);
      if (someResultExist) {
        setLookAiImageOpened(true);
      }
    }
    sidebarButtonClicked();
  }

  const realDisabled = disabled;
  const visualizerType = getCommonVisualizerType();
  const title = intl.formatMessage({id:"look.intro.aiStep.tooltip"}, {visualizerType});

  return (
    <li className="look-sidebar__list-item flex" id="aiMobileButton">
      <Tooltip title={title} placement="right">
        <IconButton aria-label={title}
                    ref={anchorRef}
                    disabled={realDisabled}
                    className={"look-icon look-sidebar__button color-primary"
                      + (introStep === neededIntroStep ? " look-sidebar__button--intro" : "")}
                    onClick={aiButtonClick}>
          {AiIcon2}
        </IconButton>
      </Tooltip>
      <LookIntroPopper anchorRef={anchorRef}
                       currentStep={neededIntroStep}
                       visualizerType={visualizerType}
                       toolTipText={"look.intro.aiStep.tooltip"}/>
      <div ref={anchorRollout}
           onClick={aiButtonClick}
           className={"cursor-pointer look-ai__sidebar transition2 absolute -translate-y-1/2 left-4"
             + (lookOverlayOpened === LOOK_OVERLAYS.aiPanel ? " look-ai__sidebar--hidden" : "")
             // + (animationActive && !animationShown && !lookAiRenderFinished ? " look-ai__sidebar--teaser" : "")
             + (lookAiRenderFinished ? " look-ai__sidebar--finished-rendering" : "")}>
        {lookAiRenderFinished ? <LookSideBarAIPanelFinishedRenderContent/> : null}
        <LookSideBarAIPanelFinishedRenderPopper anchorRef={anchorRollout}/>
      </div>
    </li>
  )
};

const mapStateToProps = (store) => {
  const {visualizersLoaded} = store.serverState;
  const {lookPageOpened, introStep, lookOverlayOpened} = store.lookState;
  const {aiResults, aiLoading, lookAiRenderFinished} = store.aiState;
  const fabricatorData = store.fabricatorState;

  return {
    lookPageOpened,
    lookOverlayOpened,
    visualizersLoadedLength: visualizersLoaded.length,
    introStep,
    aiResults,
    aiLoading,
    fabricatorData,
    lookAiRenderFinished,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookIntroStep,
  setLookAiImageOpened,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookSideBarAIMobileButton2)
  )
)
